export class ArticoliMatricola {
  id: number;
  idArticolo: number;
  matricola: string;
  propJson: string;
  dismesso: boolean;
  dataScadenza:Date;
}